// import React from "react";
// import {
//   Card,
//   CardContent,
//   Typography,
//   Box,
//   Button,
//   Chip,
//   IconButton,
// } from "@mui/material";
// import { PlayArrow, Visibility, Schedule, Launch } from "@mui/icons-material";

// const VideoCard = ({ video, onPlay }) => {
//   const handleOpenOnYouTube = (e) => {
//     e.stopPropagation();
//     window.open(
//       `https://www.youtube.com/watch?v=${video.videoId}`,
//       "_blank",
//       "noopener,noreferrer"
//     );
//   };

//   return (
//     <Card
//       variant="outlined"
//       sx={{
//         height: "100%",
//         display: "flex",
//         flexDirection: "column",
//         cursor: "pointer",
//         backgroundColor: "#ffffff",
//         borderColor: "rgba(0, 0, 0, 0.12)",
//         transition: "box-shadow 0.3s ease-in-out",
//         "&:hover": {
//           boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
//           transform: "translateY(-4px)",
//         },
//       }}
//       onClick={() => onPlay(video)}
//     >
//       <Box
//         sx={{
//           position: "relative",
//           paddingTop: "56.25%",
//           bgcolor: "black",
//           "&:hover .play-overlay": { opacity: 1 },
//         }}
//       >
//         <img
//           src={video.thumbnail}
//           alt={video.title}
//           style={{
//             position: "absolute",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "100%",
//             objectFit: "cover",
//           }}
//         />
//         <Box
//           className="play-overlay"
//           sx={{
//             position: "absolute",
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             background: "rgba(0,0,0,0.5)",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             opacity: 0,
//             transition: "opacity 0.3s ease",
//           }}
//         >
//           <Button
//             variant="contained"
//             color="error"
//             startIcon={<PlayArrow />}
//             sx={{ pointerEvents: "none" }}
//           >
//             Play Video
//           </Button>
//         </Box>
//         <Chip
//           label={video.duration}
//           size="small"
//           sx={{
//             position: "absolute",
//             bottom: 8,
//             right: 8,
//             background: "rgba(0,0,0,0.8)",
//             color: "white",
//           }}
//         />
//       </Box>

//       <CardContent
//         sx={{ flexGrow: 1, display: "flex", flexDirection: "column", p: 2 }}
//       >
//         <Typography
//           component="h3"
//           sx={{
//             fontWeight: "bold",
//             mb: 1,
//             fontSize: "1rem",
//             color: "text.primary",
//             display: "-webkit-box",
//             WebkitLineClamp: 2,
//             WebkitBoxOrient: "vertical",
//             overflow: "hidden",
//             textOverflow: "ellipsis",
//           }}
//         >
//           {video.title}
//         </Typography>
//         <Typography
//           variant="body2"
//           sx={{
//             color: "text.secondary",
//             flexGrow: 1,
//             mb: 2,
//             display: "-webkit-box",
//             WebkitLineClamp: 3,
//             WebkitBoxOrient: "vertical",
//             overflow: "hidden",
//             textOverflow: "ellipsis",
//           }}
//         >
//           {video.description}
//         </Typography>

//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "flex-end",
//             mt: "auto",
//           }}
//         >
//           <Box color="text.secondary">
//             <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
//               <Visibility sx={{ fontSize: 16 }} />
//               <Typography variant="body2">{video.views}</Typography>
//             </Box>
//             <Box
//               sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.5 }}
//             >
//               <Schedule sx={{ fontSize: 16 }} />
//               <Typography variant="body2">{video.uploadDate}</Typography>
//             </Box>
//           </Box>
//           <IconButton
//             size="small"
//             onClick={handleOpenOnYouTube}
//             aria-label="Open on YouTube"
//             title="Open on YouTube"
//             color="primary"
//           >
//             <Launch />
//           </IconButton>
//         </Box>
//       </CardContent>
//     </Card>
//   );
// };

// export default VideoCard;

import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  Chip,
  IconButton,
  Tooltip,
} from "@mui/material";
import { PlayArrow, Visibility, Schedule, Launch } from "@mui/icons-material";

const VideoCard = ({ video, onPlay }) => {
  const handleOpenOnYouTube = (e) => {
    e.stopPropagation();
    window.open(
      `https://www.youtube.com/watch?v=${video.videoId}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  const handleCardClick = () => {
    onPlay(video);
  };

  return (
    <Card
      variant="outlined"
      sx={{
        height: 420, // Fixed height
        width: "100%", // Full width of grid item
        maxWidth: 320, // Maximum width
        display: "flex",
        flexDirection: "column",
        cursor: "pointer",
        backgroundColor: "#ffffff",
        borderColor: "rgba(0, 0, 0, 0.12)",
        borderRadius: 2,
        transition: "all 0.3s ease-in-out",
        overflow: "hidden",
        "&:hover": {
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.15)",
          transform: "translateY(-6px)",
          borderColor: "primary.main",
        },
      }}
      onClick={handleCardClick}
    >
      {/* Thumbnail Section */}
      <Box
        sx={{
          position: "relative",
          paddingTop: "56.25%", // 16:9 aspect ratio
          bgcolor: "grey.900",
          overflow: "hidden",
          flexShrink: 0,
        }}
      >
        <img
          src={video.thumbnail}
          alt={video.title}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />

        {/* Hover Overlay */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background:
              "linear-gradient(0deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.2) 50%, rgba(0,0,0,0.4) 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            opacity: 0,
            transition: "all 0.3s ease",
            "&:hover": {
              opacity: 1,
            },
          }}
        >
          <Button
            variant="contained"
            color="error"
            size="large"
            startIcon={<PlayArrow />}
            sx={{
              pointerEvents: "none",
              borderRadius: 3,
              px: 3,
              py: 1,
              fontWeight: 600,
              textTransform: "none",
              fontSize: "0.9rem",
              boxShadow: "0 4px 16px rgba(211, 47, 47, 0.4)",
            }}
          >
            Play
          </Button>
        </Box>

        {/* Duration Chip */}
        <Chip
          label={video.duration}
          size="small"
          sx={{
            position: "absolute",
            bottom: 8,
            right: 8,
            background: "rgba(0, 0, 0, 0.85)",
            color: "white",
            fontWeight: 600,
            fontSize: "0.75rem",
            height: 24,
          }}
        />
      </Box>

      {/* Content Section */}
      <CardContent
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          p: 2.5,
          "&:last-child": { pb: 2.5 },
        }}
      >
        {/* Title */}
        <Typography
          component="h3"
          sx={{
            fontWeight: 700,
            fontSize: "1rem",
            lineHeight: 1.3,
            color: "text.primary",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            mb: 1.5,
            minHeight: "2.6rem", // Fixed height for 2 lines
          }}
        >
          {video.title}
        </Typography>

        {/* Description */}
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            lineHeight: 1.4,
            flexGrow: 1,
            mb: 2,
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: "0.875rem",
            minHeight: "4.2rem", // Fixed height for 3 lines
          }}
        >
          {video.description}
        </Typography>

        {/* Footer Stats */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: "auto",
            pt: 1.5,
            borderTop: 1,
            borderColor: "divider",
          }}
        >
          {/* Stats */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              <Visibility
                sx={{
                  fontSize: 18,
                  color: "text.secondary",
                }}
              />
              <Typography
                variant="caption"
                sx={{
                  fontWeight: 500,
                  color: "text.secondary",
                  fontSize: "0.8rem",
                }}
              >
                {video.views}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              <Schedule
                sx={{
                  fontSize: 16,
                  color: "text.secondary",
                }}
              />
              <Typography
                variant="caption"
                sx={{
                  fontWeight: 500,
                  color: "text.secondary",
                  fontSize: "0.8rem",
                }}
              >
                {video.uploadDate}
              </Typography>
            </Box>
          </Box>

          {/* YouTube Button */}
          <Tooltip title="Open on YouTube" arrow>
            <IconButton
              size="small"
              onClick={handleOpenOnYouTube}
              aria-label="Open on YouTube"
              sx={{
                color: "primary.main",
                backgroundColor: "rgba(25, 118, 210, 0.08)",
                "&:hover": {
                  backgroundColor: "rgba(25, 118, 210, 0.15)",
                  transform: "scale(1.1)",
                },
                transition: "all 0.2s ease",
              }}
            >
              <Launch fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      </CardContent>
    </Card>
  );
};

export default VideoCard;
